import BasePolicy from '@/policies/BasePolicy.js';

export default class ActivityUpdatePolicy extends BasePolicy {
    viewAny(user, course) {
        return (
            user.hasPermissionViaCourseTo(course, 'view an activity update') ||
            user.isStudentSupportOfCourse(course.id) ||
            user.hasGroupPermissionWithinCourse(course, 'view an activity update')
        );
    }

    view(user, activityUpdate) {
        return (
            user.hasPermissionViaCourseTo(activityUpdate.activity.course, 'view an activity update') ||
            user.hasGroupPermissionWithinCourse(activityUpdate.activity.course, 'view an activity update')
        );
    }

    create(user, activity) {
        return (
            user.hasPermissionViaCourseTo(activity.course, 'create an activity update') ||
            user.hasGroupPermissionWithinCourse(activity.course, 'create an activity update')
        );
    }

    update(user, activityUpdate) {
        return (
            user.id === activityUpdate.created_by &&
            (user.hasPermissionViaCourseTo(activityUpdate.activity.course, 'edit an activity update') ||
                user.hasGroupPermissionWithinCourse(activityUpdate.activity.course, 'edit an activity update'))
        );
    }

    delete(user, activityUpdate) {
        return (
            user.id === activityUpdate.created_by &&
            (user.hasPermissionViaCourseTo(activityUpdate.activity.course, 'delete an activity update') ||
                user.hasGroupPermissionWithinCourse(activityUpdate.activity.course, 'delete an activity update'))
        );
    }
}
